import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import SideMenuInfo from "./../components/svg/sideMenuInfo.vue";
import SideMenuTm from "./../components/svg/sideMenuTm.vue";
import SideMenuVc from "./../components/svg/sideMenuVc.vue";
import SideMenuRd from "./../components/svg/sideMenuRd.vue";
import SideMenuIu from "./../components/svg/sideMenuIu.vue";
import SideMenuSetting from "./../components/svg/sideMenuSetting.vue";
import SideMenuHere from "./../components/svg/sideMenuHere.vue";
import SideMenuWide from "./../components/svg/sideMenuWide.vue";
import SideMenuNarrow from "./../components/svg/sideMenuNarrow.vue";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'md',
    values: {
      sideMenuInfo: { component: SideMenuInfo },
      sideMenuTm: { component: SideMenuTm },
      sideMenuVc: { component: SideMenuVc },
      sideMenuRd: { component: SideMenuRd },
      sideMenuIu: { component: SideMenuIu },
      sideMenuSetting: { component: SideMenuSetting },
      sideMenuHere: { component: SideMenuHere },
      sideMenuWide: { component: SideMenuWide },
      sideMenuNarrow: { component: SideMenuNarrow },
    },
  },
  theme: {
    themes: {
      light: {
        primary: "#3041a5",
        secondary: "#b0bec5",
        accent: "#ff7700",
        error: "#b71c1c",
        warning: "#9c27b0",
        info: "#03a9f4",
        success: "#3f51b5"
      }
    }
  }
});
